import React from 'react';
import {useTranslation} from "react-i18next";
import {useHistory} from "react-router-dom";


export default function Footer() {
    const {t} = useTranslation()
    let history = useHistory();

    function handleClick() {
        history.push("/disclaimer");
    }
    return (<>
        <div className="line"/>
        <div className="footerBlock">
            <footer className="footer">
                <div className="footerText">
                    2024 © K2G.AI
                </div>
                <div className="footerText">
                    <a href={'https://k2g.ai/privacy-policy'} className="footerText underLineText" rel="noreferrer"  target="_blank">
                        {t('bottom_privacy')}
                        {/*Privacy Policy*/}
                    </a> &nbsp;
                    <span className="underLineText" onClick={handleClick}>
                        {t('bottom_disclaimer')}
                        {/*Disclaimer*/}
                    </span>
                </div>
                <div className="footerText">
                    Powered by K2G
                </div>
            </footer>
        </div>
    </>)
};

